import { getAdminUserData, patchAdminUserBalance } from '../components/api';
import { useHookState } from '../components/NotificationApiHook';
import { UserBalancePatchDTO } from './DTO';

export const useAdminUsersData = () => {
  const { notificationState } = useHookState();
  const fetchUserInfo = (userLogin: string) => getAdminUserData(notificationState, userLogin);

  const patchUserBalance = (userBalanceChange: UserBalancePatchDTO) =>
    patchAdminUserBalance(notificationState, userBalanceChange);

  return { patchUserBalance, fetchUserInfo };
};
